import { render, staticRenderFns } from "./NewsEdit.vue?vue&type=template&id=5984254d&scoped=true"
import script from "./NewsEdit.vue?vue&type=script&lang=js"
export * from "./NewsEdit.vue?vue&type=script&lang=js"
import style0 from "./NewsEdit.vue?vue&type=style&index=0&id=5984254d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984254d",
  null
  
)

export default component.exports